import { memo } from "react"

const IconImage = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14.88 8.08C13.7754 8.08 12.88 7.18457 12.88 6.08C12.88 4.97543 13.7754 4.08 14.88 4.08C15.9846 4.08 16.88 4.97543 16.88 6.08C16.88 7.18457 15.9846 8.08 14.88 8.08Z"
        fill="#486284"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M8.76 1.07005e-06L13 6.99382e-07C17.4183 3.13124e-07 21 3.58172 21 8L21 12.24C21 16.6583 17.4183 20.24 13 20.24L8.76 20.24C4.34172 20.24 0.760002 16.6583 0.760001 12.24L0.760001 8C0.760001 5.87827 1.60285 3.84344 3.10315 2.34315C4.60344 0.842856 6.63827 1.25554e-06 8.76 1.07005e-06ZM13 1.5L8.76 1.5C5.51408 1.50507 2.76944 3.90396 2.33 7.12L3.88 7.12C8.05324 7.1234 11.9121 9.33825 14.02 12.94C15.3364 11.8943 16.9688 11.3267 18.65 11.33L19.5 11.33L19.5 8C19.4945 4.41243 16.5876 1.50551 13 1.5ZM18.65 12.83L19.47 12.83C19.2528 15.1883 17.7701 17.2418 15.6 18.19C15.5283 16.8552 15.2273 15.5426 14.71 14.31C15.8015 13.3571 17.201 12.8314 18.65 12.83ZM8.76 18.74L13 18.74C13.376 18.7385 13.7509 18.7017 14.12 18.63C13.9951 13.0613 9.45005 8.60946 3.88 8.6L2.26 8.6L2.26 12.24C2.26551 15.8276 5.17243 18.7345 8.76 18.74Z"
        fill="#486284"
      />
    </svg>
  )
}

export default memo(IconImage)
